// extracted by mini-css-extract-plugin
export default {"buttonToAnswerQuestion":"h6-z","disabled":"i6-z","seeAllAnswers":"j6-z"};